"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeatmapYAxisCategories = exports.getHeatmapXAxisCategories = void 0;

var _url = _interopRequireDefault(require("url"));

var _experimentTypeUtils = require("./experimentTypeUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getHeatmapXAxisCategories = function getHeatmapXAxisCategories(_ref) {
  var columnHeaders = _ref.columnHeaders,
      experiment = _ref.experiment;

  if ((0, _experimentTypeUtils.isMultiExperiment)(experiment)) {
    return columnHeaders.map(function (columnHeader) {
      return {
        label: columnHeader.factorValue,
        id: columnHeader.factorValueOntologyTermId || "",
        info: {
          trackId: "",
          tooltip: {}
        }
      };
    });
  } else if ((0, _experimentTypeUtils.isDifferential)(experiment)) {
    return columnHeaders.map(function (columnHeader) {
      return {
        label: columnHeader.displayName,
        id: columnHeader.id,
        info: {
          trackId: columnHeader.id,
          tooltip: _objectSpread({}, columnHeader.contrastSummary)
        }
      };
    });
  } else {
    return columnHeaders.map(function (columnHeader) {
      return {
        label: columnHeader.factorValue,
        id: columnHeader.factorValueOntologyTermId || "",
        info: {
          trackId: columnHeader.assayGroupId,
          tooltip: {
            properties: columnHeader.assayGroupSummary.properties,
            replicates: columnHeader.assayGroupSummary.replicates
          }
        }
      };
    });
  }
};

exports.getHeatmapXAxisCategories = getHeatmapXAxisCategories;

var getHeatmapYAxisCategories = function getHeatmapYAxisCategories(_ref2) {
  var rows = _ref2.rows,
      inProxy = _ref2.inProxy,
      atlasUrl = _ref2.atlasUrl;
  return rows.map(function (profile) {
    return {
      label: profile.name,
      id: profile.id,
      info: {
        trackId: profile.id,
        designElement: profile.designElement || "",
        url: _url["default"].resolve(inProxy + atlasUrl, profile.uri),
        experimentType: profile.experimentType
      }
    };
  });
};

exports.getHeatmapYAxisCategories = getHeatmapYAxisCategories;